<div class="container">
    <div>
        <img style="max-width: 100%; height: auto;" [src]="imageSrc"/>
    </div>
</div>
